import React from 'react';
import { Customer } from '@/hooks/useCustomers';
import { useSourceManager } from '@/hooks/useSourceManager';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';

interface APISourceCardProps {
  customer: Customer;
  onSetupMode?: (mode: string) => void;
}

export const APISourceCard: React.FC<APISourceCardProps> = ({ customer }) => {
  const { sources, enableSource, disableSource, loading } = useSourceManager(customer.id);
  
  const apiSource = sources.api;
  const isActive = apiSource?.status === 'active';
  
  const handleToggle = async () => {
    if (isActive) {
      await disableSource('api');
    } else {
      await enableSource('api', { auto_enabled: true });
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-cyan-500/10 rounded-lg flex items-center justify-center">
            <span className="text-xl">🔗</span>
          </div>
          <div>
            <h3 className="font-medium">API Integration</h3>
            <p className="text-sm text-muted-foreground">Custom endpoints and webhooks</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Badge variant={isActive ? "default" : "secondary"}>
            {isActive ? "✅ Active" : "⚙️ Setup Required"}
          </Badge>
          <Button size="sm" onClick={handleToggle} disabled={loading}>
            {isActive ? "Disable" : "Enable"}
          </Button>
        </div>
      </div>
    </div>
  );
};